import { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import styles from './index.module.scss'
import API, { commonApiInvoker } from '@api/api'
import { Button, Divider, Empty, Image, Input, message, Select, Space, Spin, Checkbox, Radio } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import InfiniteScroll from 'react-infinite-scroll-component'
import Utils from "@utils/utils"
import ImagePreviewWithLabel from '@view/compoents/ImagePreviewWithLabel';
import eventBus from '@utils/eventBus';
import { useLocation } from 'react-router-dom'
import { flushSync } from 'react-dom'
import PSAIModal from "@PSAIComponents/PSAIModal";
import JSZip from 'jszip'
import axios from 'axios'
import { saveAs } from "file-saver";
import DeliveryImageItem from "../DeliveryImageItem";

const uncheckIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.38428 9.55206L7.76003 14.9278L17.6156 5.07227" stroke="#BACCF4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)
const checkIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.38428 9.55206L7.76003 14.9278L17.6156 5.07227" stroke="#006EFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

const DeliveryItem = ({
    item,
    onPreview,
    onSubmit,
    isMultiSelect,
    multiSelectType,
    selectRowKeys,
    onSelect,
    onDownload,
}) => {
    const {skuCode} = item
    const firstSkuImage = useMemo(() => {
        return item.skuImages?.[0]
    }, [item])

    // 没有全部审核时，点击【提交反馈】时，toast提示
    // 全部已反馈的，不显示按钮
    const allImageSubmited = useMemo(() => {
        const deliveryImages = item.deliveryImages || []
        return deliveryImages.every(item => !!item.deliverySubmit)
    }, [item])
    // 全部已标记的，高亮按钮
    const allImageMarked = useMemo(() => {
        const deliveryImages = item.deliveryImages || []
        return deliveryImages.every(item => {
            return item.status == 2 || // 已通过/已下载
                item.status == 3 || // 不通过
                item.status == -1 // 已取消
        })
    }, [item])
    const handleSubmit = useCallback(() => {
        onSubmit([item.id])
    }, [item, onSubmit])
    const handleDownload = useCallback(() => {
        onDownload([item.id])
    }, [item, onDownload])
    const handleWarn = useCallback(() => {
        message.warning('存在图片没有标记意见，请标记后提交')
    }, [])
    // 多选时，是否选中
    const isSelected = useMemo(() => {
        return selectRowKeys.includes(item.id)
    }, [item, selectRowKeys])
    // 允许多选
    const selectDisabled = useMemo(() => {
        // if (multiSelectType == 'multiFeedback') {
        //     return !(!allImageSubmited && allImageMarked)
        // }
        return false
    }, [allImageSubmited, allImageMarked])
    const handleSelect = useCallback((e) => {
        if (!isMultiSelect) return
        e.stopPropagation()
        if (selectDisabled) return
        onSelect(item)
    }, [item, isMultiSelect, onSelect, selectDisabled])

    return (
        <div
            className={styles.DeliveryItem}
            style={isMultiSelect ? (selectDisabled ? {cursor:"not-allowed"} : {cursor:"pointer"}) : {}}
            onClickCapture={handleSelect}
        >
            <div className={styles.DeliveryItemTitle} style={isMultiSelect? {paddingLeft:12} : {}}>
            {
                !isMultiSelect ? null :
                isSelected ? <div className={styles.MultiSelect}>{checkIcon}</div> :
                <div className={styles.MultiSelect}>{uncheckIcon}</div>
            }{
                <div className={styles.SkuCode}>{skuCode}</div>
            }{
                <Space className={styles.BtnGroup}>
                {
                    isMultiSelect ? <Button style={{width: 96}} disabled>下载</Button> :
                    <Button style={{width: 96}} onClick={handleDownload}>下载</Button>
                } {
                    isMultiSelect ? <Button style={{width: 144}} disabled>提交反馈</Button> :
                    allImageSubmited ? <Button style={{width: 144}} disabled>提交反馈</Button> :
                    allImageMarked ? <Button style={{width: 144}} type="primary" onClick={handleSubmit}>提交反馈</Button> :
                    <Button style={{width: 144}} onClick={handleWarn}>提交反馈</Button>
                }
                </Space>
            }
            </div>
            <div className={styles.DeliveryItemContent}>
                <div style={{width: 60, height: 80}}>
                    <Image
                        rootClassName={styles.ImageItem}
                        src={firstSkuImage ? Utils.getImgThumbnail(firstSkuImage) : require('@assets/images/delivery/cloth_default.png')}
                        alt="sku"
                        fallback={require('@assets/images/fallback.png')}
                        preview={firstSkuImage ? {src: firstSkuImage} : false}
                    />
                </div>
                <div className={styles.DeliveryItemImages}>
                {
                    item.deliveryImages.map(item => (
                        <DeliveryImageItem
                            key={item.imageId}
                            item={item}
                            onPreview={(data) => onPreview({...data, spuId: item.spuCode})}
                        />
                    ))
                }
                </div>
            </div>
        </div>
    )
}

export default DeliveryItem